/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type FormFieldTypeEnum = "array" | "boolean" | "boolean_switch" | "container" | "container_image_slug" | "date" | "datetime" | "doc_slug" | "file_slug" | "image_slug" | "linked_contacts" | "multi_select" | "number" | "parent_shipment" | "port" | "rate_card" | "rich_text" | "searchable" | "shipment_image_slug" | "shipping_line" | "string" | "vessel" | "voyage" | "%future added value";
export type TicketEntityTypeEnum = "containers" | "shipments" | "%future added value";
export type TicketTypeEnum = "add_documents_and_photos" | "misc" | "request_for_documents" | "request_for_shipment_release" | "request_to_add_contact_link" | "request_to_create_a_new_contact" | "request_to_create_a_new_container" | "request_to_create_a_new_poa" | "request_to_create_a_new_shipment" | "request_to_create_container_shipment" | "signed_document_details" | "%future added value";
export type LiveRequestAddDialogQueryVariables = {
    entitySlug: string;
    entityType: TicketEntityTypeEnum;
    ticketType?: TicketTypeEnum | null;
};
export type LiveRequestAddDialogQueryResponse = {
    readonly infoRaiseTicketForm: {
        readonly formSchema: {
            readonly fieldSet: ReadonlyArray<{
                readonly name: string;
                readonly type: FormFieldTypeEnum;
                readonly required: boolean;
                readonly title: string | null;
                readonly description: string | null;
                readonly format: string | null;
                readonly enum: ReadonlyArray<string | null> | null;
                readonly enumTitles: ReadonlyArray<string | null> | null;
            }>;
        };
    };
};
export type LiveRequestAddDialogQuery = {
    readonly response: LiveRequestAddDialogQueryResponse;
    readonly variables: LiveRequestAddDialogQueryVariables;
};



/*
query LiveRequestAddDialogQuery(
  $entitySlug: String!
  $entityType: TicketEntityTypeEnum!
  $ticketType: TicketTypeEnum
) {
  infoRaiseTicketForm(entitySlug: $entitySlug, entityType: $entityType, ticketType: $ticketType) {
    formSchema {
      fieldSet {
        name
        type
        required
        title
        description
        format
        enum
        enumTitles
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "entitySlug"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "entityType"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ticketType"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "entitySlug",
        "variableName": "entitySlug"
      },
      {
        "kind": "Variable",
        "name": "entityType",
        "variableName": "entityType"
      },
      {
        "kind": "Variable",
        "name": "ticketType",
        "variableName": "ticketType"
      }
    ],
    "concreteType": "InfoRaiseTicketFormResponse",
    "kind": "LinkedField",
    "name": "infoRaiseTicketForm",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FormSchema",
        "kind": "LinkedField",
        "name": "formSchema",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FormField",
            "kind": "LinkedField",
            "name": "fieldSet",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "required",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "format",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "enum",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "enumTitles",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LiveRequestAddDialogQuery",
    "selections": (v1/*: any*/),
    "type": "ApplicationQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LiveRequestAddDialogQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4e40f996efb7ea5bcac7742becf74da7",
    "id": null,
    "metadata": {},
    "name": "LiveRequestAddDialogQuery",
    "operationKind": "query",
    "text": "query LiveRequestAddDialogQuery(\n  $entitySlug: String!\n  $entityType: TicketEntityTypeEnum!\n  $ticketType: TicketTypeEnum\n) {\n  infoRaiseTicketForm(entitySlug: $entitySlug, entityType: $entityType, ticketType: $ticketType) {\n    formSchema {\n      fieldSet {\n        name\n        type\n        required\n        title\n        description\n        format\n        enum\n        enumTitles\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'a8e95f4b7474f9386dcbeb31f47a53b1';
export default node;
